var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

var STEPS = 4, cur = 1, done = new Set();
var selectedSignage = new Set();
var otherItems = new Set();

/* Display name map for all signage types */
var SIGN_LABELS = {
  outdoor_building:'Outdoor Building Signage', window_perf:'View-Through Window Perf', storefront_hours:'Storefront Hours',
  raised_signage:'Interior Raised Signage', wall_graphics:'Wall Graphics', floor_graphics:'Floor Graphics',
  yard_signs:'Yard Signs', banner_stands:'Banner Stands', pvc_banners:'PVC Banners',
  a_frame_signs:'A-Frame Signs & Sign Inserts', coroplast_signs:'Coroplast Signs', backdrop_displays:'Backdrop Displays',
  real_estate_signs:'Real estate signs', parking_regulatory:'Parking & regulatory signs', construction_signs:'Construction site signs',
  fence_barricade:'Fence & barricade graphics', directional_wayfinding_ext:'Directional & wayfinding (exterior)',
  hanging_signs:'Hanging signs', lobby_reception:'Lobby & reception signs', acrylic_glass:'Acrylic & glass prints',
  directional_wayfinding_int:'Directional & wayfinding (interior)', backlit_lightbox:'Backlit displays & lightbox graphics',
  pop_displays:'Point-of-purchase displays', shelf_talkers:'Shelf talkers & aisle markers', menu_boards:'Menu boards',
  posters_prints:'Posters & mounted prints', tabletop_displays:'Tabletop displays', temp_event_signage:'Temporary event signage',
  reflective_safety:'Reflective & safety signs', aluminum_composite:'Aluminum composite signs', magnetic_signs:'Magnetic signs',
  dry_erase:'Dry erase boards & writable graphics', fabric_graphics:'Repositionable fabric graphics',
  backlit_film:'Backlit film prints', frosted_etched:'Frosted & etched glass vinyl'
};

var TIMELINE_LABELS = {
  same_day:'\uD83D\uDEA8 Same Day \u2014 URGENT', urgent:'\uD83D\uDD34 Urgent (24\u201348 hrs)', rush:'\uD83D\uDD36 Rush (2\u20133 days)',
  standard:'Standard (5\u20137 days)', '30_days':'Within 30 days', '30_60_days':'30\u201360 days',
  '60_90_days':'60\u201390+ days', flexible:'No Rush \u2014 Flexible'
};

/* ── Multi-select: main grid ── */
function toggleSignage(el) {
  var v = el.dataset.value;
  if (v === 'other') { toggleOtherPanel(el); return; }
  if (selectedSignage.has(v)) { selectedSignage.delete(v); el.classList.remove('selected'); }
  else { selectedSignage.add(v); el.classList.add('selected'); }
  updateCount();
}

function toggleOtherPanel(el) {
  var panel = document.getElementById('otherPanel');
  if (el.classList.contains('selected')) {
    el.classList.remove('selected');
    panel.classList.remove('visible');
    // Clear all other items
    otherItems.clear();
    panel.querySelectorAll('.other-item.selected').forEach(function(i) { i.classList.remove('selected'); });
  } else {
    el.classList.add('selected');
    panel.classList.add('visible');
  }
  updateCount();
}

function toggleOtherItem(el) {
  var v = el.dataset.value;
  if (otherItems.has(v)) { otherItems.delete(v); el.classList.remove('selected'); }
  else { otherItems.add(v); el.classList.add('selected'); }
  updateCount();
}

function updateCount() {
  var total = selectedSignage.size + otherItems.size;
  var el = document.getElementById('selectionCount');
  var txt = document.getElementById('selectionCountText');
  if (total > 0) {
    el.style.display = 'inline-flex';
    txt.textContent = total + ' item' + (total > 1 ? 's' : '') + ' selected';
  } else {
    el.style.display = 'none';
  }
}

/* ── Contact Method ── */
function pickContact(btn) {
  document.querySelectorAll('.fp .contact-method-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('signContactMethod').value = btn.dataset.value;
}

/* ── Phone Format ── */
function formatPhone(input) {
  var v = input.value.replace(/\D/g, '');
  if (v.length > 10) v = v.substring(0, 10);
  if (v.length >= 7) input.value = '(' + v.substring(0,3) + ') ' + v.substring(3,6) + '-' + v.substring(6);
  else if (v.length >= 4) input.value = '(' + v.substring(0,3) + ') ' + v.substring(3);
  else if (v.length > 0) input.value = '(' + v;
}

/* ── File Upload ── */
function handleFiles(input) {
  var el = document.getElementById('signFileNames');
  el.textContent = input.files.length ? 'Selected: ' + Array.from(input.files).map(function(f) { return f.name; }).join(', ') : '';
}

/* ── Navigation ── */
function goToStep(target) {
  if (target < 1 || target > STEPS || target === cur) return;
  if (target > cur) {
    for (var s = cur; s < target; s++) {
      var errs = validate(s);
      if (errs.length) { highlight(s, errs); showToast('Please fill in all required fields'); return; }
      done.add(s);
    }
  }
  if (target < cur && !validate(cur).length) done.add(cur);
  switchCard(target);
}

function switchCard(target) {
  var c = document.querySelector('.fp .step-card[data-step="'+cur+'"]');
  if (c) c.classList.remove('active');
  if (target === STEPS) buildSummary();
  var t = document.querySelector('.fp .step-card[data-step="'+target+'"]');
  if (t) { void t.offsetWidth; t.classList.add('active'); }
  cur = target;
  document.querySelectorAll('.fp .step-indicator').forEach(function(ind) {
    var s = parseInt(ind.dataset.step);
    ind.classList.remove('active','completed');
    if (s === cur) ind.classList.add('active');
    else if (done.has(s)) ind.classList.add('completed');
  });
  document.getElementById('signStepper').scrollIntoView({ behavior:'smooth', block:'start' });
}

/* ── Validation ── */
function validate(step) {
  var e = [];
  if (step === 1) {
    if (!document.getElementById('signFullName').value.trim()) e.push('signFullName');
    var em = document.getElementById('signEmail').value.trim();
    if (!em || em.indexOf('@') === -1) e.push('signEmail');
    if (!document.getElementById('signContactMethod').value) e.push('contactMethod');
  }
  if (step === 2) {
    if (selectedSignage.size === 0 && otherItems.size === 0) e.push('signageGrid');
  }
  if (step === 3) {
    if (!document.getElementById('signQuantity').value.trim()) e.push('signQuantity');
    if (!document.getElementById('signTimeline').value) e.push('signTimeline');
  }
  return e;
}

function highlight(step, errs) {
  clearErrors();
  var card = document.querySelector('.fp .step-card[data-step="'+step+'"]');
  if (card) { card.classList.remove('shake'); void card.offsetWidth; card.classList.add('shake'); }
  errs.forEach(function(k) {
    var el = document.getElementById(k);
    if (el && el.closest('.field-group')) el.closest('.field-group').classList.add('field-error');
    if (k === 'contactMethod') { var cm = document.querySelector('.fp .contact-method-group'); if (cm) cm.closest('.field-group').classList.add('field-error'); }
    if (k === 'signageGrid') { var g = document.getElementById('signageGrid'); if (g) { g.style.outline='2px solid var(--fwg-red)'; g.style.outlineOffset='4px'; g.style.borderRadius='12px'; } }
  });
}

function clearErrors() {
  document.querySelectorAll('.fp .field-error').forEach(function(el) { el.classList.remove('field-error'); });
  var g = document.getElementById('signageGrid');
  if (g) { g.style.outline=''; g.style.outlineOffset=''; }
}
document.addEventListener('input', function(e) { if (e.target.closest('.fp')) clearErrors(); });
document.addEventListener('click', function(e) { if (e.target.closest('.fp .ms-btn, .fp .other-item, .fp .contact-method-btn')) clearErrors(); });

/* ── Summary ── */
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
function row(l, v) { return '<div class="summary__row"><span class="summary__label">'+l+'</span><span class="summary__value">'+(v||'\u2014')+'</span></div>'; }
function editBtn(s) { return '<button type="button" class="btn-edit" onclick="goToStep('+s+')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>'; }
function secHead(n, t, s) { return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">'+n+'</span> '+t+'</div>'+editBtn(s)+'</div>'; }

function buildSummary() {
  var h = '';
  // Contact
  h += '<div class="summary__section">' + secHead('01','Contact Info',1);
  h += row('Name', esc(document.getElementById('signFullName').value));
  h += row('Email', esc(document.getElementById('signEmail').value));
  var ph = document.getElementById('signPhone').value.trim();
  if (ph) h += row('Phone', esc(ph));
  var co = document.getElementById('signCompany').value.trim();
  if (co) h += row('Company', esc(co));
  var cm = document.getElementById('signContactMethod').value;
  h += row('Contact Via', cm === 'email' ? 'Email' : cm === 'text' ? 'Text' : cm === 'call' ? 'Call' : '');
  h += '</div>';

  // Signage Types
  h += '<div class="summary__section">' + secHead('02','Signage Types',2);
  var allTypes = [];
  selectedSignage.forEach(function(v) { allTypes.push(SIGN_LABELS[v] || v); });
  otherItems.forEach(function(v) { allTypes.push(SIGN_LABELS[v] || v); });
  h += row('Selected', allTypes.join(', '));
  h += '</div>';

  // Details
  h += '<div class="summary__section">' + secHead('03','Project Details',3);
  h += row('Quantity', esc(document.getElementById('signQuantity').value));
  var sz = document.getElementById('signSize').value.trim();
  if (sz) h += row('Size', esc(sz));
  var tl = document.getElementById('signTimeline').value;
  h += row('Timeline', TIMELINE_LABELS[tl] || tl);
  var fi = document.querySelector('input[name="signage_files"]');
  if (fi && fi.files.length) h += row('Files', Array.from(fi.files).map(function(f) { return esc(f.name); }).join(', '));
  var notes = document.getElementById('signNotes').value.trim();
  if (notes) h += row('Notes', esc(notes));
  h += '</div>';

  document.getElementById('signSummary').innerHTML = h;
}

/* ── Toast ── */
function showToast(m) {
  var t = document.getElementById('signToast');
  t.textContent = m;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2200);
}

/* ── File Upload to Supabase ── */
function uploadFile(file, folder) {
  var timestamp = Date.now();
  var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  var path = folder + '/' + timestamp + '_' + safeName;
  return fetch(
    FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path,
    {
      method: 'POST',
      headers: {
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'x-upsert': 'true'
      },
      body: file
    }
  ).then(function(response) {
    if (!response.ok) { return response.text().then(function(t) { console.error('Upload failed:', file.name, t); return null; }); }
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  });
}

function uploadFiles(fileInput, folder) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) return Promise.resolve([]);
  var promises = [];
  for (var i = 0; i < fileInput.files.length; i++) { promises.push(uploadFile(fileInput.files[i], folder)); }
  return Promise.all(promises).then(function(urls) { return urls.filter(function(u) { return u !== null; }); });
}

/* ── Submit ── */
document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('fwgSignageForm').addEventListener('submit', function(e) {
    e.preventDefault();
    for (var i = 1; i <= STEPS; i++) {
      var errs = validate(i);
      if (errs.length) { switchCard(i); setTimeout(function() { highlight(i, errs); }, 50); showToast('Please fill in all required fields'); return; }
    }

    var submitBtn = document.querySelector('.fp .btn-submit');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Submitting...</span>';
    }

    var allTypes = [];
    selectedSignage.forEach(function(v) { allTypes.push(v); });
    otherItems.forEach(function(v) { allTypes.push(v); });

    var submissionId = Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var folder = 'submissions/' + submissionId;
    var fileInput = document.querySelector('input[name="signage_files"]');

    uploadFiles(fileInput, folder + '/designs')
    .then(function(designUrls) {
      var payload = {
        form_type: 'signage_promo',
        contact_name: document.getElementById('signFullName').value.trim(),
        email: document.getElementById('signEmail').value.trim(),
        phone: document.getElementById('signPhone').value.trim() || null,
        company: document.getElementById('signCompany').value.trim() || null,
        contact_method: document.getElementById('signContactMethod').value,
        signage_types: allTypes,
        quantity: document.getElementById('signQuantity').value.trim(),
        size: document.getElementById('signSize').value.trim() || null,
        timeline: document.getElementById('signTimeline').value,
        notes: document.getElementById('signNotes').value.trim() || null,
        additional_info: document.getElementById('signAdditional').value.trim() || null,
        design_file_urls: designUrls,
        source_page: window.location.pathname,
        user_agent: navigator.userAgent
      };

      return fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(response) {
      if (!response.ok) { return response.text().then(function(t) { throw new Error('Submission failed: ' + t); }); }
      showToast('Inquiry submitted! We\'ll be in touch within 24 hours.');
      setTimeout(function() { window.location.href = FWG_CONFIG.THANK_YOU_URL; }, 800);
    })
    .catch(function(err) {
      console.error('Form submission error:', err);
      showToast('Something went wrong. Please try again or call us directly.');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalText; }
    });
  });
});
